export default __webpack_public_path__ + "static/media/karen.b1ac9611.jpeg";